import { connect } from 'react-redux';
import { handleCreateItem, handleCreateTitle } from '../../../actions/admin_actions';
import { NewTitleWithStyles as NewTitle } from '../../../components/admin/titles/TitleForm';

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
    adminFetchItem: state.adminFetchItem.adminFetchItem,
    adminCreateItem: state.adminCreateItem.adminCreateItem,
    adminCreateTitle: state.adminCreateTitle.adminCreateTitle
  }
}

const AdminNewTitleContainer = connect(mapStateToProps, { handleCreateItem, handleCreateTitle })(NewTitle)

export default AdminNewTitleContainer;